import {useTenant} from '@store/settings'
import React, {createContext, useContext, useEffect, useMemo, useState} from 'react'
import {useSelector} from 'react-redux'
import {domainConfigs} from './domains'
import {themes} from './themes'
import {ThemeProvider} from 'styled-components'

const DomainContext = createContext()

export const useDomain = () => {
  const context = useContext(DomainContext)
  if (!context) {
    throw new Error('useDomain must be used within a DomainProvider')
  }
  return context
}

// Pluralization helper functions
const getPlural = singular => {
  return `${singular}s`
}

export const DomainProvider = ({children}) => {
  const user = useSelector(state => state.auth.user)
  const [tenant, setTenant] = useTenant()
  const [domain, setDomain] = useState('all')

  useEffect(() => {
    console.log('DomainProvider useEffect triggered', {user, tenant})
    const newDomain = tenant?.domain || user?.t_domain || 'all'
    setDomain(newDomain)
    console.log('DomainProvider useEffect', {
      tenantDomain: tenant?.domain,
      userDomain: user?.t_domain,
      newDomain
    })
  }, [user, tenant])

  const config = useMemo(() => domainConfigs[domain] || domainConfigs['all'], [domain])
  const theme = useMemo(() => themes[config.theme] || themes.default, [config])

  // Add pluralization to terms
  const termsWithPlurals = useMemo(() => {
    const baseTerms = config.terms
    return {
      ...baseTerms,
      tenant: 'Company',
      tenants: 'Companies',
      sites: getPlural(baseTerms.site),
      gateways: getPlural(baseTerms.gateway),
      cameras: getPlural(baseTerms.camera),
      targets: getPlural(baseTerms.target)
    }
  }, [config.terms])

  return (
    <DomainContext.Provider
      value={{
        domain,
        terms: termsWithPlurals,
        images: config.images,
        theme,
        setDomain,
        setTenant
      }}
    >
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </DomainContext.Provider>
  )
}
